(function () {
  var STORAGE_KEY = 'shipping_location_confirmed';

  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
  } catch (e) {
    /* Private browsing — continue to show popup */
  }

  var popup = document.getElementById('shipping-location-popup');
  if (!popup) return;

  popup.style.display = '';
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.style.top = '-' + window.scrollY + 'px';

  var popupForm = popup.querySelector('form');
  var select = document.getElementById('ShippingLocationSelect');
  var hiddenInput = popup.querySelector('input[name="country_code"]');

  if (select && hiddenInput) {
    select.addEventListener('change', function () {
      hiddenInput.value = this.value;
    });
  }

  if (popupForm) {
    popupForm.addEventListener('submit', function () {
      var btn = popupForm.querySelector('.shipping-popup--button');
      if (btn) btn.classList.add('is-loading');
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {
        /* Private browsing — no-op */
      }
    });
  }
})();
